import { Paragraph } from '@app/shared/ui/atoms/Common';
import { cookieImage } from '@app/assets';
import { MagicCookieItem } from '@app/shared/types/pages/cookiesShop';

interface MagicCookieProps {
  magicCookie: MagicCookieItem;
  size?: 'sm' | 'lg';
}

export function MagicCookie({ size = 'sm', magicCookie }: MagicCookieProps) {
  return (
    <div className="relative rounded-lg bg-blue-dark px-4 py-2">
      <Paragraph size="lg" className="mx-auto flex w-fit gap-1 text-orange-500">
        {magicCookie.cookieAmount}
        <img src={cookieImage} alt="cookies" className="w-5 object-contain" />
      </Paragraph>
      <img
        src={magicCookie.image}
        alt={magicCookie.alt}
        className={`mx-auto my-2 aspect-square object-contain ${size === 'sm' ? 'w-4/5' : 'w-3/5'}`}
      />
      <Paragraph
        size={size}
        className="mx-auto w-fit rounded-md border-2 border-accent px-1 text-accent"
      >
        {magicCookie.price} TON
      </Paragraph>
      {!!magicCookie?.discount && (
        <Paragraph
          size={size === 'sm' ? size : 'md'}
          className={`absolute -bottom-3 -right-4 flex items-center justify-center rounded-full bg-accent text-foreground ${size === 'sm' ? 'h-7 w-7' : 'h-10 w-10'}`}
        >
          -{magicCookie.discount}%
        </Paragraph>
      )}
    </div>
  );
}
